// extracted by mini-css-extract-plugin
export var fadeInAnimation = "Grid-module--fadeInAnimation--30ee5";
export var grid = "Grid-module--grid--4c304";